/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Surveys_TaglineInputs */



/**
* | output |
* | --- |
* | "Condition and draught surveys, cargo supervision, incident investigation and charterer representation." |
*
* @param {Service_Surveys_TaglineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_surveys_tagline = /** @type {((inputs?: Service_Surveys_TaglineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Surveys_TaglineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("状况检验、水尺计重、货物监装监卸、事故调查及租家代表。")
	return /** @type {LocalizedString} */ ("Condition and draught surveys, cargo supervision, incident investigation and charterer representation.")
});